/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./relate-review.vue?vue&type=template&id=61394cee&scoped=true&"
import script from "./relate-review.vue?vue&type=script&lang=js&"
export * from "./relate-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61394cee",
  null
  
)

export default component.exports